import React from 'react';
import { styled } from '@mui/system';

const SwitchWrapper = styled('label')`
  display: inline-block;
  height: 20px;
  position: relative;
  width: 40px;
`;

const SwitchInput = styled('input')`
  display: none;
`;

const Slider = styled('div')`
  background-color: #ccc;
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: .4s;
  border-radius: 20px;

  &::before {
    background-color: #fff;
    bottom: 2px;
    content: "";
    height: 16px;
    left: 2px;
    position: absolute;
    transition: .3s;
    width: 16px;
    border-radius: 50%;
  }

  ${({ checked }) => checked && `
    background-color: #66bb6a;
    &::before {
      transform: translateX(20px);
    }
  `}
`;

export default function CustomSwitch({ checked, onChange, name }) {
    return (
        <SwitchWrapper>
            <SwitchInput
                type="checkbox"
                checked={checked}
                onChange={onChange}
                name={name}
            />
            <Slider checked={checked} />
        </SwitchWrapper>
    );
}